import React, { useEffect, useState, useContext } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { MetadataContent } from '@jutro/uiconfig';
import { ErrorCodes } from 'gw-portals-util-adac-js';
import { useDependencies } from 'gw-portals-dependency-react';
import { CommunicationHistory, CommunicationVariablesContext } from 'gw-capability-fnol-adac-react';
import usePortalModeBasedLabel from '../../hooks/usePortalModeBasedLabel';
import metadata from './AdacHistoryPage.metadata.json5';
import messages from './AdacHistoryPage.messages';
import styles from './AdacHistoryPage.module.scss';

function AdacHistoryPage({ history }) {
    const [commHistDto, setCommHistDto] = useState({});
    const { ClaimService } = useDependencies('ClaimService');

    const { communicationVariables } = useContext(CommunicationVariablesContext)
    const { token, sessionUUID, historyRedirectPath } = communicationVariables;

    useEffect(() => {
        ClaimService.retrieveCommunicationHistory(token, sessionUUID)
            .then((result) => {
                setCommHistDto(result);
            })
            .catch((error) => {
                if (error.appErrorCode === ErrorCodes.SESSION_EXPIRED) {
                    history.push({
                        pathname: '/sessionexpired'
                    });
                } else {
                    history.push({ pathname: '/trylater' });
                }
            });
    }, [])

    const overrides = {
        pageHeaderTitle: {
            content: usePortalModeBasedLabel('pageHeaderTitle')
        },
        backButton: {
            onClick: () => history.push({
                pathname: historyRedirectPath
            })
        },
        historyEntries: {
            dataToDisplay: commHistDto.historyEntries,
            filtersToBeShown: ['type', 'from']
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            CommunicationHistory
        },
        resolveCallbackMap: {}
    };
    return <MetadataContent
        uiProps={metadata.pageContent}
        overrideProps={overrides}
        {...resolvers}
    />;
}

export default withRouter(AdacHistoryPage);
